import { Intent, Position, Toaster } from "@blueprintjs/core";
import '@blueprintjs/core/lib/css/blueprint.css';

export default Toaster.create({
    position: Position.TOP,
    intent: Intent.SUCCESS,
    maxToasts:1
});
